/* ════════════════════════════════════════════════════════════════
   fo-offer-countdown.js — Badge "Oferta especial" del Bloque D.

   El badge alterna dos estados dentro de la misma píldora verde:
     · TEXTO  "Oferta especial"  → visible 3 s
     · TIEMPO  HH:MM:SS           → visible 5 s
   El contador cuenta hasta la próxima medianoche (00:00) en
   America/Mexico_City y se reinicia solo a las 12am CDMX cada día,
   sin importar el huso horario del navegador del visitante.

   Un único motor maneja todos los [data-fo-countdown] de la página y
   re-consulta el DOM en cada tick, así sigue funcionando con la
   paginación AJAX del tema (js-pagination-result).
   Sin JS, el CSS deja fijo el texto "Oferta especial".
   ════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var SELECTOR = '[data-fo-countdown]';
  var TIME_SELECTOR = '.fo-gc__badge-time';
  var TEXT_MS = 3000; // "Oferta especial" visible 3 s
  var TIME_MS = 5000; // temporizador visible 5 s

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  // Segundos hasta la próxima medianoche en America/Mexico_City.
  function secondsUntilMexicoMidnight() {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Mexico_City',
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
    var parts = fmt.formatToParts(new Date());
    var h = 0, m = 0, s = 0;
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (p.type === 'hour') h = parseInt(p.value, 10);
      else if (p.type === 'minute') m = parseInt(p.value, 10);
      else if (p.type === 'second') s = parseInt(p.value, 10);
    }
    if (h === 24) h = 0; // algunos motores devuelven 24 a medianoche
    var rem = 86400 - (h * 3600 + m * 60 + s);
    if (rem <= 0) rem += 86400;
    return rem;
  }

  function format(rem) {
    return pad(Math.floor(rem / 3600)) + ':' +
           pad(Math.floor((rem % 3600) / 60)) + ':' +
           pad(rem % 60);
  }

  // Mantiene los números al día cada segundo (aunque el badge muestre el texto).
  function tick() {
    var nodes = document.querySelectorAll(SELECTOR);
    if (!nodes.length) return;
    var text = format(secondsUntilMexicoMidnight());
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i].querySelector(TIME_SELECTOR);
      if (el && el.textContent !== text) el.textContent = text;
    }
  }

  // Alterna texto/temporizador en todos los badges a la vez.
  function setShowingTime(showTime) {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      if (showTime) nodes[i].classList.add('is-showing-time');
      else nodes[i].classList.remove('is-showing-time');
    }
  }

  function toggleLoop(showTime) {
    setShowingTime(showTime);
    setTimeout(function () { toggleLoop(!showTime); }, showTime ? TIME_MS : TEXT_MS);
  }

  function start() {
    tick();
    setInterval(tick, 1000);
    toggleLoop(false); // arranca mostrando el texto "Oferta especial"
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
